import {type WorkspaceSingleRunQuery} from '../../../generated/graphql';
import {getRunState, parseConfig} from '../../../util/runs';
import {type KeyVal} from '../../../util/runTypes';

export type SingleRunModeRun = {
  id: string;
  name: string;
  createdAt: string;
  displayName: string;
  defaultColorIndex?: number;
  state: string;
  tags: {
    id: string;
    name: string;
    colorIndex: number;
  }[];
  _wandb: KeyVal;
};

/**
 * Converts WorkspaceSingleRun query data to SingleRunModeRun type expected by the context
 */
export function mapQueryDataToRun(
  data: WorkspaceSingleRunQuery | undefined
): SingleRunModeRun | undefined {
  const raw = data?.project?.run;
  if (!raw) {
    return undefined;
  }

  const {_wandb = {}} = parseConfig(raw.config, raw.name) ?? {};
  return {
    id: raw.id,
    name: raw.name,
    createdAt: raw.createdAt,
    displayName: raw.displayName ?? raw.name,
    defaultColorIndex: raw.defaultColorIndex ?? undefined,
    state: getRunState(raw.state),
    tags: raw.tags.map(tag => ({
      id: tag.id,
      name: tag.name,
      colorIndex: tag.colorIndex,
    })),
    _wandb,
  };
}
